import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError, getCookie } from '../../utils'

export const contractTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS', 'ADD_EMPTY'], 'CONTRACTS');
export const contractUpdateTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'UPDATE_CONTRACT');
export const multipleContractsUpdateTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'UPDATE_CONTRACTS');



export const requestContract = () => {
    return {
        type: contractTypes.REQUEST,
    };
};

export const receiveContract = (response, query={}) => {
    return {
        type: contractTypes.RECEIVE,
        query: query,
        data: response,
    };
};

export const receiveContractError = (response) => {
    return {
        type: contractTypes.ERROR,
        error: response,
    };
};

export const requestContractUpdate = () => {
    return {
        type: contractUpdateTypes.REQUEST,
    };
};

export const requestMultipleContractUpdate = () => {
    return {
        type: multipleContractsUpdateTypes.REQUEST,
    };
};

export const receiveContractUpdate = (response, query={}) => {
    return {
        type: contractUpdateTypes.RECEIVE,
        query: query,
        data: response,
    };
};

export const receiveMultipleContractUpdate = (response, query={}) => {
    return {
        type: multipleContractsUpdateTypes.RECEIVE,
        query: query,
        data: response,
    };
};

export const receiveContractUpdateError = (response) => {
    return {
        type: contractUpdateTypes.ERROR,
        error: response,
    };
};

export const receiveMultipleContractUpdateError = (response) => {
    return {
        type: multipleContractsUpdateTypes.ERROR,
        error: response,
    };
};

export const fetchContract = (contractId) => {
    return dispatch => {

        let success = true

        const apiUrl = "/api/v1/contracts/"

        dispatch(requestContract());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch((contractId === undefined) ? apiUrl : apiUrl+`${contractId}/`, {
            headers: headers,
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            if (success) {
                dispatch(receiveContract(response, contractId));
            } else {
                dispatch(receiveContractError(response))
            }
        })
        .catch(handleNetworkError);
    };
};

 
export const updateContract = (contractId, files) => {

    let data = files.map((file) => {
        return (
            {
                data: file.base64,
                type: file.type,
                title: file.name,
            }
        )
    })
    return dispatch => {

        let success = true;
        const apiUrl = "/api/v1/contract/";

        dispatch(requestContractUpdate());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl+`${contractId}/update/`, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
        })
        .then(response => {
            if(response.status !== 200) {
                success = false
            }
            return response
        })
        .then(response => {
            if (success) {
                dispatch(receiveContractUpdate(response.status, contractId));
            } else {
                dispatch(receiveContractUpdateError(response.status))
            }
        })
        .catch(handleNetworkError);
    };
};

// Multiple files for multiple contracts
export const updateContracts = (contractsIds, files) => {
    let data = {
        files: [],
        ids: contractsIds
    }

    data.files = files.map((file) => {
        return (
            {
                data: file.base64,
                type: file.type,
                title: file.name,
            }
        )
    })

    return dispatch => {
        let success = true;
        const apiUrl = "/api/v1/contracts/multiple/update/";

        dispatch(requestMultipleContractUpdate());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-CSRFToken': getCookie("csrftoken"),
        }

        return fetch(apiUrl, {
            headers: headers,
            method: 'POST',
            body: JSON.stringify(data),
            credentials: 'include',
        })
        .then(response => {
            if(response.status !== 200) {
                success = false
            }
            return response
        })
        .then(response => {
            if (success) {
                dispatch(receiveMultipleContractUpdate(response.status));
            } else {
                dispatch(receiveMultipleContractUpdateError(response.status))
            }
        })
        .catch(handleNetworkError);
    };
};